import type { ArticleDTO } from '../types';
import { useSettings } from '../settings';
import { navigate } from '../lib/router';

export default function Popular({ items }: { items: ArticleDTO[] }) {
  const { t } = useSettings();
  if (items.length === 0) return null;

  return (
    <section aria-labelledby="popular-heading">
      <div className="border-t-4 border-t-ink pt-3">
        <h2 id="popular-heading" className="font-serif text-xl font-bold text-ink">
          {t('mostRead')}
        </h2>
      </div>

      <ol className="mt-4 border-t border-rule">
        {items.map((article, index) => (
          <li key={article.id} className="border-b border-rule">
            <a
              href={`/article/${article.id}`}
              onClick={(event) => {
                event.preventDefault();
                navigate(`/article/${article.id}`);
              }}
              className="group flex gap-3 py-3"
            >
              <span className="w-6 shrink-0 font-serif text-2xl leading-none text-ink-dim/60">
                {index + 1}
              </span>
              <span className="flex-1">
                <span className="block font-serif text-[15px] font-semibold leading-snug text-ink-soft group-hover:underline group-hover:decoration-1 group-hover:underline-offset-2">
                  {article.title}
                </span>
                <span className="mt-1 flex items-center gap-2 font-mono text-[9px] uppercase tracking-[0.14em] text-ink-dim">
                  <span>{article.agent.name}</span>
                  <span aria-hidden="true">·</span>
                  <span>
                    {article.view_count.toLocaleString()} {t('views')}
                  </span>
                </span>
              </span>
            </a>
          </li>
        ))}
      </ol>
    </section>
  );
}
